import Vue from 'vue'
import VueRouter from 'vue-router'
import axios from 'axios'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'pages-login',
    component: () => import('@/views/pages/Login.vue'),
    meta: {
      layout: 'blank',
    },
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: () => import('@/views/dashboard/Dashboard.vue'),
  },
  {
    path: '/all-data/agent',
    name: 'Agent',
    component: () => import('@/views/all-data/agent.vue'),
  },
  {
    path: '/all-data/hotel',
    name: 'Hotel',
    component: () => import('@/views/all-data/hotel.vue'),
  },
  {
    path: '/all-data/restaurant',
    name: 'Restaurant',
    component: () => import('@/views/all-data/restaurant.vue'),
  },
  {
    path: '/all-data/activity',
    name: 'Activity',
    component: () => import('@/views/all-data/activity.vue'),
  },
  {
    path: '/all-data/transport',
    name: 'Transport',
    component: () => import('@/views/all-data/transport.vue'),
  },
  {
    path: '/all-data/guide',
    name: 'Guide',
    component: () => import('@/views/all-data/guide.vue'),
  },
  {
    path: '/all-data/agent',
    name: 'Agent',
    component: () => import('@/views/all-data/agent.vue'),
  },
  {
    path: '/all-data/other',
    name: 'Other',
    component: () => import('@/views/all-data/other.vue'),
  },
  {
    path: '/all-data/region',
    name: 'Region',
    component: () => import('@/views/all-data/region.vue'),
  },
  {
    path: '/all-data/entrance',
    name: 'entrance_fee',
    component: () => import('@/views/all-data/entrance.vue'),
  },
  {
    path: '/NewTour',
    name: 'New Tour',
    component: () => import('@/views/blm/NewTour.vue'),
  },
  {
    path: '/ServiceOrder',
    name: 'Service Order',
    component: () => import('@/views/blm/Service Order.vue'),
  },
  {
    path: '/ItinerariData',
    name: 'Itinerari Data',
    component: () => import('@/views/blm/Itinerari Data.vue'),
  },
  {
    path: '/Invoice',
    name: 'invoice',
    component: () => import('@/views/blm/Invoice.vue'),
  },
  {
    path: '/Status',
    name: 'Status Tour',
    component: () => import('@/views/blm/List Status.vue'),
  },
  {
    path: '/StatusPayment',
    name: 'Status Payment',
    component: () => import('@/views/blm/Status Payment.vue'),
  },
  {
    path: '/pages/account-settings',
    name: 'pages-account-settings',
    component: () => import('@/views/pages/account-settings/AccountSettings.vue'),
  },
  {
    path: '/pages/login',
    name: 'pages-login',
    component: () => import('@/views/pages/Login.vue'),
    meta: {
      layout: 'blank',
    },
  },
  {
    path: '/pages/register',
    name: 'pages-register',
    component: () => import('@/views/pages/Register.vue'),
    meta: {
      layout: 'blank',
    },
  },
  {
    path: '/error-404',
    name: 'error-404',
    component: () => import('@/views/Error.vue'),
    meta: {
      layout: 'blank',
    },
  },
  {
    path: '*',
    redirect: 'error-404',
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
})

router.beforeEach(async (to, from, next) => {
  axios.defaults.headers.common.Authorization = `Bearer ${localStorage.getItem('token')}`
  if (!localStorage.getItem('token') && to.name !== 'pages-login') {
    // redirect the user to the login page
    next({ name: 'pages-login' })
  }
  next()
})

/* router.beforeEach((to, from, next) => {
  axios.defaults.headers.common.Authorization = `Bearer ${localStorage.getItem('token')}`
  next()
})

/* console.log(store.state.isLoggedIn)
  if (to.name !== 'pages-login' && !store.state.isLoggedIn) {
    next({ name: 'pages-login' })
  } else {
    axios.defaults.headers.common.Authorization = `Bearer ${store.state.user.access_token}`
    next()
  }

  /* const token = JSON.parse(localStorage.getItem('user'))

  if (token) {
    axios.defaults.headers.common.Authorization = `Bearer ${token.access_token}`
    axios.get('/user').then(res => {
      if (res.status === 200) {
        store.state.user = res.data.data
        next()
      } else if (res.status !== 200) {
        next('/login')
      }
    })
  } else {
    next()
  }
}) */
export default router
